import { render, staticRenderFns } from "./tipofday.vue?vue&type=template&id=c1d35c6c&scoped=true&"
import script from "./tipofday.vue?vue&type=script&lang=js&"
export * from "./tipofday.vue?vue&type=script&lang=js&"
import style0 from "./tipofday.vue?vue&type=style&index=0&id=c1d35c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d35c6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1d35c6c')) {
      api.createRecord('c1d35c6c', component.options)
    } else {
      api.reload('c1d35c6c', component.options)
    }
    module.hot.accept("./tipofday.vue?vue&type=template&id=c1d35c6c&scoped=true&", function () {
      api.rerender('c1d35c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tod/tipofday.vue"
export default component.exports